import { atom } from "jotai";

import { currentModalStepAtom } from "../../stores";

export const enterAddPlayersPrivateStepAtom = atom(
  null,
  (_get, set, payload?: { bookingIndex?: number } | null) => {
    set(
      currentModalStepAtom,
      payload?.bookingIndex == null
        ? { type: "AddPlayerPrivate" }
        : { type: "AddPlayerPrivate", bookingIndex: payload.bookingIndex }
    );
  }
);
